export enum BaseContentContainerFormat {
  singleWithoutActionButtons = 'singleWithoutActionButtons',
  doubleWithoutActionButtons = 'doubleWithoutActionButtons',
  singleWithActionButtons = 'singleWithActionButtons',
  doubleWithActionButtons = 'doubleWithActionButtons',
  doubleUpperAndLargeBottom = 'doubleUpperAndLargeBottom'
}

export enum BaseContentContainerBiggerSide {
  half = 'half',
  right = 'right',
  left = 'left',
}

export enum BaseContentContainerActionButtonPosition {
  top = 'top',
  bottom = 'bottom'
}
